import { Directive, ElementRef, Input } from "@angular/core";
import { NgControl } from "@angular/forms";

@Directive({
  selector: "[anchorDisabled]",
})
export class AnchorDisabledDirective {
  @Input() set anchorDisabled(condition: boolean) {
    const nativeElement = this.el.nativeElement;
    if (condition) {
      nativeElement.setAttribute("disabled", true);
      return;
    }

    nativeElement.removeAttribute("disabled");
  }

  constructor(private el: ElementRef) {}
}
